import "./projects.css"
import React  from "react"
import { FaExternalLinkAlt, FaAngleLeft, FaAngleRight } from 'react-icons/fa';

const projects = [
  {
    id: 0,
    name: "Live Chat",
    link: "https://chrome.google.com/webstore/detail/live-chat-for-all-website/jndncpcadllfnlbdlmfdjfachfkjnmki",
    img: "https://lh3.googleusercontent.com/vuoxPo1Tqs58YOnwZkcCk7ZB-ovNGo098ZGCcn_jERVdfec8qAI-Yg9Aaovr9e2Ezd9MxK62R_uR3EDz71cxlaSOVpU=w640-h400-e365-rj-sc0x00ffffff",
    text: "A Chrome extension to chat with people using same website at same time",
  },
  {
    id: 1,
    name: "Cryptic Hunt",
    link: "https://cryptic-web.vercel.app/",
    img: "/cryptic.png",
    text: "I made this terminal based Cryptic Hunt website for college fest ",
  },
  {
    id: 2,
    name: "Tweak",
    link: "http://tweak-web.herokuapp.com",
    img: "https://image.freepik.com/free-vector/young-boy-girl-text-message-chat-app-doodle-draw-illustration-character-asset-by-arkana-studio_189741-119.jpg",
    text: "Tweak is a Blogging website it was my first project and used for writting short blogs.",
  },
  {
    id: 3,
    name: "Detain-or-Not",
    link: "https://detain-or-not.vercel.app/",
    img: "/detain.webp",
    text: "A webapp that take college ID and give a detailed ananlysis of attendance, I used web scraping to get data from college website",
  }
];



class Projects extends React.Component {
    constructor(){
        super()
        this._div = React.createRef();
        this.state = {
            project:projects[0]
        }
    }
    
    ChangeTab(num){
        this.setState({project:projects[num]})
        // console.log(num)
    }
    
    Shift(n){
        
    }
    
    render(){
        return(
            <div id="projects">
                <div className="nav-space"></div>
                <h1 className="section-head">Projects</h1>
                <div className="project-container-desktop">

                    <div className="project-container">
                        <div className="project-img">
                            <img src={this.state.project.img} alt={this.state.project.name} />
                        </div>
                        <div className="project-title">
                            <span id="project-name">{this.state.project.name}</span>
                            <a href={this.state.project.link} target="_blank" rel="noreferrer" className="project-link">OPEN&nbsp;<FaExternalLinkAlt /></a>
                        </div>
                        <div className="project-txt">
                            <p>
                                {this.state.project.text}
                            </p>
                        </div>

                        <div className="project-nav-container">

                            <button id="slideLeft" className="pro-nav-button" 
                            onClick={()=> this._div.current.scrollLeft -= "100"}
                            ><FaAngleLeft/></button>


                            <div ref={this._div} className="project-nav">
                                {projects.map((proj)=>{
                                    if(proj.id === this.state.project.id){
                                        return(<span id={proj.id} onClick={() => this.ChangeTab(proj.id)} className="project-tab active">{proj.name}</span>)
                                    } 
                                    else{
                                        return(<span id={proj.id} onClick={() => this.ChangeTab(proj.id)} className="project-tab">{proj.name}</span>)
                                    }    
                                })}
                            </div>


                            <button id="slideRight" className="pro-nav-button" 
                            onClick={()=> this._div.current.scrollLeft += "100"}
                            ><FaAngleRight/></button>

                        </div>


                    </div>
                    
                    <div className="project-img-desktop">
                        <img src={this.state.project.img} alt={this.state.project.name} />
                    </div>
                </div>

            </div>
        );

    }

}




export default Projects;
